<template>
  <div class="main_center lawEnforcement_detail">
    <div class="top-content">
      <div class="left-navbar">
        <el-button @click="backRouter">返回</el-button>
      </div>
    </div>
    <div class="right-content">
      <el-form :model="form" label-width="200px" ref="form">
        <el-card class="box-card">
        <div class="clearfix" slot="header">
          <span>监督人员登记信息</span>
        </div>

          <el-row>
            <el-col :span="num/2">
              <el-form-item label="状态：" prop="status">
                <span>{{ form.status?'启用':'禁用'}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="num/2">
              <el-form-item label="人员类型：" prop="personType">
                <span>{{form.personType == '1'?'开评标监督人员':'其他'}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="num">
              <el-form-item label="参与权限：" prop="participationRights">
                <span>{{form.participationRightsName||'--'}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="num/2">
              <el-form-item label="姓名：" prop="personName">
                {{form.personName}}
              </el-form-item>
            </el-col>
            <el-col :span="num/2">
              <el-form-item label="手机号：" prop="phone">
                {{form.phone}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="num/2">
              <el-form-item label="身份证号：" prop="idNo">
                {{form.idNo}}
              </el-form-item>
            </el-col>
            <el-col :span="num/2">
              <el-form-item label="所属监督部门：" prop="deptId">
                {{form.deptName}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="num">
              <el-form-item label="主要工作内容：" prop="workContent">
                {{form.workContent}}
              </el-form-item>
            </el-col>
          </el-row>


      </el-card>
        <el-card class="box-card">
          <div class="clearfix" slot="header">
            <span>相关附件</span>
          </div>
          <el-row>
            <el-col :key="index" :span="num" v-for="(item,index) in form.attachments" >
              <affix-doc
                      :item.sync="item"
                      :name="item.fileTypeName"
                      :type="'person_register_att'"
                      class="affixDown"
                      labelWidth="200px"
              />
            </el-col>
          </el-row>
        </el-card>
      </el-form>
    </div>
  </div>
</template>

<script>
  import affixDoc from '@/components/affixDoc';
  import {dealAttachment} from '@/utils';
  import {mapState} from "vuex";
  export default {
    props: ['mainContentViewHeight'],
    components:{
      affixDoc
    },
    data() {
      return {
        visible: false,
        id: "",
        form: {
          id: '',
          status: false,
          personType: '',
          participationRightsName:'',
          personName: '',
          name: '',
          idNo:'',
          deptName:'',
          workContent:'',
          attachments:[], // 附件数据
        },
        num:20,
        personTypeData:[
          {
            name:'开评标监督人员',
            value:'1'
          },
        ],
      }
    },
    computed: {
      ...mapState({
        personRegisterAttConfig: (state) => state.dataDictionary.personRegisterAttConfig,
      })
    },
    watch: {
      personRegisterAttConfig: {
        immediate: true,
        deep: true, // 深度监听
        handler(val, newVal) {
          // 初始化附件数据
          this.$nextTick(()=>{
            let attachments = JSON.parse(JSON.stringify(this.personRegisterAttConfig));
            this.form.attachments = attachments;
          })

        }
      }
    },
    created() {
      this.$store.dispatch('dataDictionary/getPersonRegisterAttConfig');//获取附件配置项数据
    },
    activated() {
      this.id = (this.$route.query && this.$route.query.id ) || '' ;
      this.init(this.id);
    },
    methods: {
      init(id) {
        this.form.id = id || ''
        this.visible = true
        if (this.form.id) {
          this.$httpReq({
            url: '/openEvalPersonRegister/get?id=' + this.form.id,
            method: 'get'
          }).then(({data}) => {
            let resData = data.data
            if (data && data.code === '1') {
              this.form = resData
            }
            // 附件数据处理start
            let attachments= this.personRegisterAttConfig.length > 0?JSON.parse(JSON.stringify(this.personRegisterAttConfig)):JSON.parse(JSON.stringify(this.form.attachments));
            this.form.attachments = dealAttachment(attachments,resData.attachments);
          })
        }
      },
      backRouter(){
        this.$refs['form'].resetFields();
        this.form={};
        Object.assign(this.$data.form, this.$options.data().form)
        this.tabsCloseCurrent()
        this.$router.push({name:'personRegister_list'})
      },
    }
  }
</script>
<style lang="scss" scoped>
  /deep/ .el-dialog{
    width: 600px;
  }
  .el-form{
    margin: 20px 90px 30px 20px;
  }
  .extractorAvoidunit{
    &>div>div>div{
      position: relative;
    }
    .el-input{
      width: 350px;
      margin-left: 15px;
    }
  }

  .el-autocomplete{
    width: 350px;
  }
  .unitTitle{
    position: absolute;
    font-size: 12px;
    top: -16px;
    left: 30px;
    color: #3E8EF7;
    background: #fff;
    height: 14px;
    line-height: 14px;
  }
  .unitTitle2{
    position: absolute;
    font-size: 12px;
    top: -16px;
    left: 300px;
    color: #3E8EF7;
    background: #fff;
    height: 14px;
    line-height: 14px;
  }
  .imgBox{
    cursor: pointer;
    margin: 0 5px;
    width: 20px;
    &:hover{
      background-color: rgba($color: #eee, $alpha: 1);
    }
  }
</style>